import { Days } from '../model/days';
export class DaysBuilder {
    static buildDays(data) {
        let days = null;
        days = new Days();
        days.day = data.day;
        days.in_operations = data.in_operations;
        days.in_passengers = data.in_passengers;
        days.out_operations = data.out_operations;
        days.out_passengers = data.out_passengers;
        return days;
    }
}
//# sourceMappingURL=days-builder.js.map